import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompContext } from '@/context/__project__/CompContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'

import { CompLocationWrapperCore } from '../core/location/wrapper'
import { CompLocation } from './CompLocation'

/**
 * CompLocationWrapper
 */
const CompLocationWrapper = () => {
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()

  // brandkit
  const [themeState] = useBuilderColorSchemeV2()
  const mode = themeState.current

  return (
    <CompLocationWrapperCore infos={{ ...compContext, activeLayer }} style={{ mode }}>
      {(props) => <CompLocation {...props} />}
    </CompLocationWrapperCore>
  )
}

export default CompLocationWrapper
